export default "__VITE_ASSET__BeAo_t74__"